<template>
  <VueJsModalPrimary
    v-bind="attrs.modal"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary :truncate="true">
        Distribute "{{ survey.name }}"
      </HeaderLargePrimary>
      <div>
        <TextRegular :style="style.text">
          Any workspace member with this link can take the survey.
        </TextRegular>
        <InputSecondary
          v-model="surveyUrl"
          :disabled="true"
        />
      </div>
      <div :style="style.footer">
        <ButtonSecondary @click="close">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          :disabled="!survey.isPublished"
          @click="copyLink"
        >
          Copy
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import InputSecondary from '@modules/v2/input/input-secondary'
  import TextRegular from '@modules/v2/text/text-regular'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalSurveySharePrimary',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      InputSecondary,
      TextRegular,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        name: MODAL_WINDOW_NAMES.SHARE_SURVEY_PRIMARY,
        survey: {},
        surveyUrl: '',
        attrs: {
          modal: {
            height: '290px',
            maxWidth: 480,
            name: MODAL_WINDOW_NAMES.SHARE_SURVEY_PRIMARY,
            width: '90%',
          },
        },
        style: {
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: Layout.space.lg,
            width: '100%',
          },
          footer: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          text: {
            margin: `0 0 ${Layout.space.lg}`,
          },
        },
      };
    },
    methods: {
      beforeOpen: function (e) {
        this.clearCache();
        this.survey = e?.params?.survey;
        if (this.survey === undefined || this.survey === null) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load survey',
          );
          this.close();
        }
      },
      clearCache: function () {
        this.survey = {};
      },
      close: function () {
        this.$modal.hide(this.name);
      },
      copyLink: function () {
        navigator.clipboard.writeText(this.surveyUrl);
        this.$store.commit('notification/setMessage', 'Copied Link');
      },
    },
    watch: {
      survey: {
        handler: function (newVal, oldVal) {
          const baseUrl = (
            `${process.env.VUE_APP_API_SERVER_BASE_URL}:` +
            process.env.VUE_APP_API_SERVER_PORT
          );
          const protocol = baseUrl.includes('localhost') ? 'http' : 'https';
          this.surveyUrl = `${protocol}:${baseUrl}/surveys/${newVal.code}/`;
        },
        deep: true,
      },
    },
  };
</script>
